import React from 'react'
import SingleUnitMax from '../commonDetails/SingleUnitMax'
import { localize } from '../../../../util/Localizer'
import NoResultsMsg from '../../../../widgets/common/NoResultsMsg'

const isAvailable = item => {
  const { availableAmount = 0, spentAmount = 0 } = item
  return (availableAmount > 0 || spentAmount > 0)
}

const UnitMax = (props) => {
  let individualUnit = props.data
  return (
    <div className='unitMax'>
      {individualUnit.length > 0 ? (
        individualUnit.filter(isAvailable).map((item, i) => {
          return (<SingleUnitMax key={i} data={item} index={i} />)
        })
      ) : (
        <NoResultsMsg message={localize('pages.benefitDetails.unitMax.empty')} />
      )}
    </div>
  )
}

export default UnitMax



// WEBPACK FOOTER //
// ./src/widgets/Member/benefitsWidgets/commonDetails/UnitMax.js